import { jsx as _jsx } from "react/jsx-runtime";
import 'react';
import classNames from 'classnames';
const FOUR_BY_THREE = '4by3';
const SIXTEEN_BY_NINE = '16by9';
const ResponsiveVideo = (props) => {
    const { src, className = '', allowFullScreen = true, aspectRatio = '16by9' } = props;
    const wrapperClassName = classNames('video-responsive', `video-responsive-${aspectRatio}`, className && className);
    return (_jsx("div", Object.assign({ className: wrapperClassName }, { children: _jsx("iframe", { src: src, allowFullScreen: allowFullScreen }) })));
};
ResponsiveVideo.ASPECT_RATIO_4_BY_3 = FOUR_BY_THREE;
ResponsiveVideo.ASPECT_RATIO_16_BY_9 = SIXTEEN_BY_NINE;
export default ResponsiveVideo;
